import React, { useRef } from 'react';
import styles from './style.module.scss';
import { Accordion } from './accordion.js';
import { useSelector } from 'react-redux';

export const ProductAccordions = () => {
  const accordions = useSelector(
    (state) => state.modules.modules.productAccordions
  );

  let accordionRefs = useRef([]);

  const closeAll = () => {
    accordionRefs.current.forEach((ref) => {
      ref?.closeAccordion();
      console.log('close');
    });
  };

  const accordionRenders = accordions.map((accordion, index) => {
    return (
      <Accordion
        openedOrClosed={'closed'}
        handleOpen={closeAll}
        key={index}
        ref={(el) => (accordionRefs.current[index] = el)}
        bgMedia={accordion.accordion.background_media}
        specialContent={accordion.accordion.special_content_module}
        accordionHeader={accordion.accordion.accordion_header}
        contentHeader={accordion.accordion.accordion_content_header}
        accordionContent={accordion.accordion.accordion_content}
        buttonLabel={'see more'}
        buttonLink={accordion.accordion.accordion_link}
      ></Accordion>
    );
  });

  return (
    <section className={styles['accordions']}>
      <div>{accordionRenders}</div>
    </section>
  );
};
